<template>
  <nav class="navbar" :class="{ 'scrolled': isScrolled }">
    <div class="container">
      <div class="logo">
        <router-link to="/" class="logo-link">
          <img src="../assets/logo.png" alt="隆之智环保" class="logo-image">
        </router-link>
      </div>
      <div class="menu-toggle" @click="toggleMenu">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <ul class="nav-links" :class="{ 'active': isMenuOpen }">
        <li><router-link to="/" exact>网站首页</router-link></li>
        <li><router-link to="/about">关于我们</router-link></li>
        <li><router-link to="/news">新闻资讯</router-link></li>
        <li><router-link to="/covs">VOCs综合管控</router-link></li>
        <li><router-link to="/ldar">ldar检测</router-link></li>
        <li><router-link to="/environmental">排污/环保管家</router-link></li>
        <li><router-link to="/soil-remediation">场调/土壤修复</router-link></li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppNavbar',
  data() {
    return {
      isScrolled: false,
      isMenuOpen: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    handleResize() {
      if (window.innerWidth > 768) {
        this.isMenuOpen = false;
      }
    }
  }
}
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: all 0.3s ease;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-image {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.menu-toggle {
  display: none;
  cursor: pointer;
}

.bar {
  width: 25px;
  height: 3px;
  background-color: #333;
  margin: 5px 0;
  transition: all 0.3s ease;
}

.nav-links {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav-links li {
  margin-left: 20px;
}

.nav-links a {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s ease;
}

@media screen and (max-width: 768px) {
  .menu-toggle {
    display: block;
  }

  .nav-links {
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    background-color: #fff;
    flex-direction: column;
    align-items: center;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .nav-links.active {
    max-height: 500px;
  }

  .nav-links li {
    margin: 15px 0;
  }
}

@media screen and (max-width: 768px) {
  .logo-image {
    height: 40px;
  }
}

@media screen and (max-width: 480px) {
  .logo-image {
    height: 35px;
  }
  
  .nav-links a {
    font-size: 14px;
  }
}

.nav-links a:hover {
  color: #42b983;
}

.nav-links a.router-link-active {
  color: #42b983;
  font-weight: 600;
}

/* 滚动时的导航栏样式 */
.navbar.scrolled {
  background-color: #333;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.navbar.scrolled .nav-links a {
  color: #fff;
}

.navbar.scrolled .nav-links a:hover {
  color: #42b983;
}

.navbar.scrolled .nav-links a.router-link-active {
  color: #42b983;
}

.navbar.scrolled .bar {
  background-color: #fff;
}

.navbar.scrolled .logo-image {
  filter: brightness(0) invert(1);
}

/* 移动端菜单滚动样式 */
@media screen and (max-width: 768px) {
  .navbar.scrolled .nav-links {
    background-color: #333;
  }
  
  .navbar.scrolled .nav-links a {
    color: #fff;
  }
  
  .navbar.scrolled .nav-links a:hover {
    color: #42b983;
  }
  
  .navbar.scrolled .nav-links a.router-link-active {
    color: #42b983;
  }
}
</style>